import React, { useEffect } from "react";
import {
  IonPage,
  IonCard,
  IonRow,
  IonCol,
  IonIcon,
  IonText,
} from "@ionic/react";
import DOMPurify from 'isomorphic-dompurify';
import "./CarrierProfilePage.scss";
import { CARRIER_PROFILE_FOOTER } from "../../../utils/constants";
import { setScreenName } from "../../../utils/Analytics";

const CarrierProfilePage = (props: any) => {
  const {
    userDetails
  } = props;
    const getAddress = () => {
        let address = '';
        if(userDetails && userDetails.memberDetailsResponse &&
            userDetails.memberDetailsResponse.carrierInfo && userDetails.memberDetailsResponse.carrierInfo.addressLine1){
            address = address +  userDetails.memberDetailsResponse.carrierInfo.addressLine1 + ', ';
        }
        if(userDetails && userDetails.memberDetailsResponse &&
            userDetails.memberDetailsResponse.carrierInfo && userDetails.memberDetailsResponse.carrierInfo.addressLine2){
            address = address + userDetails.memberDetailsResponse.carrierInfo.addressLine2 + ', ';
        }
        if(userDetails && userDetails.memberDetailsResponse &&
            userDetails.memberDetailsResponse.carrierInfo && userDetails.memberDetailsResponse.carrierInfo.city){
            address = address + userDetails.memberDetailsResponse.carrierInfo.city + ', ';
        }
        if(userDetails && userDetails.memberDetailsResponse &&
            userDetails.memberDetailsResponse.carrierInfo && userDetails.memberDetailsResponse.carrierInfo.state){
            address = address + userDetails.memberDetailsResponse.carrierInfo.state + ', ';
        }
        if(userDetails && userDetails.memberDetailsResponse &&
            userDetails.memberDetailsResponse.carrierInfo && userDetails.memberDetailsResponse.carrierInfo.country){
            address = address + userDetails.memberDetailsResponse.carrierInfo.country + ', ';
        }
        if(userDetails && userDetails.memberDetailsResponse &&
            userDetails.memberDetailsResponse.carrierInfo && userDetails.memberDetailsResponse.carrierInfo.postalCode) {
            address = address + userDetails.memberDetailsResponse.carrierInfo.postalCode;
        }
        return address;
    }

    const getDateFormat = (date: any) => {
        if(date){
            let dateArray = date.split(' ')[0].split('-');
            let mm = dateArray[1];
            let dd = dateArray[2];
            let yyyy = dateArray[0];
            return `${mm}/${dd}/${yyyy}`;
        }
        return date;        
    }

    const currencyFormatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
    });

    const getContactName = (firstName: string | null, lastName: string | null) => {
        let name = '';
        if(firstName) {
            name = name + firstName + ' ';
        }
        if(lastName) {
            name = name + lastName;
        }
        return name;
    }
    useEffect(() => {
        setScreenName("screen_carrier_profile");
    }, []);

    const getPhoneData = userDetails?.memberDetailsResponse?.carrierInfo?.otherContacts?.length > 0 && 
    userDetails.memberDetailsResponse.carrierInfo.otherContacts[0].contactPhoneNumber ? 
    userDetails.memberDetailsResponse.carrierInfo.otherContacts[0].contactPhoneNumber : '-';

    const createMarkup = (content : any) => {
        const clean = DOMPurify.sanitize(content);
        return {__html: clean};
      };

    return (
       <IonPage className="carrierProfilePage">
           <IonText className="carrierProfileText" data-testid="carrierProfileText">{'Company Profile'}</IonText>
           <IonRow className="carrierProfileCardContainer">
                <IonCard className="mainCarrierCard">
                    <IonRow className="mainCarrierCardSection">
                        <IonRow className="carrierInfoText">
                            <IonText>{'Carrier Info'}</IonText>
                        </IonRow>
                        <IonRow className="carrierDetailsPart">
                            <IonCol className="carrierInfoLeftCol">
                                <IonText className="carrierHeadings">{'Carrier Name'}</IonText>
                                <IonText className="carrierInfoData">{userDetails && userDetails.memberDetailsResponse &&
      userDetails.memberDetailsResponse.carrierInfo && userDetails.memberDetailsResponse.carrierInfo.carrierName}</IonText>
                                <IonText className="carrierHeadings">{'Carrier MC#'}</IonText>
                                <IonText className="carrierInfoData">{userDetails && userDetails.memberDetailsResponse &&
      userDetails.memberDetailsResponse.carrierInfo && userDetails.memberDetailsResponse.carrierInfo.carrierMCNo}</IonText>
                            </IonCol>
                            <IonCol className="carrierInfoRightCol">
                                <IonText className="carrierHeadings">{'Carrier ID'}</IonText>
                                <IonText className="carrierInfoData">{userDetails && userDetails.memberDetailsResponse &&
      userDetails.memberDetailsResponse.carrierInfo && userDetails.memberDetailsResponse.carrierInfo.commonCarrierId}</IonText>
                                <IonText className="carrierHeadings">{'USDOT #'}</IonText>
                                <IonText className="carrierInfoData">{userDetails && userDetails.memberDetailsResponse &&
      userDetails.memberDetailsResponse.carrierInfo && userDetails.memberDetailsResponse.carrierInfo.carrierUsDOTNo}</IonText>
                            </IonCol>
                        </IonRow>
                    </IonRow>
                    <IonRow className="mainCarrierCardSection">
                        <IonRow className="carrierInfoText">
                            <IonText>{'Contact Details'}</IonText>
                        </IonRow>
                        <IonRow className="carrierDetailsPart">
                            <IonCol className="carrierInfoLeftCol">
                                <IonText className="carrierHeadings">{'Carrier Address'}</IonText>
                                <IonText className="carrierInfoData">{getAddress() ? getAddress() : '-'}</IonText>
                                <IonText className="carrierHeadings">{'Contact Phone'}</IonText>
                                <IonText className="carrierInfoData">{(userDetails?.memberDetailsResponse?.carrierInfo?.primaryContact) ? 
      userDetails.memberDetailsResponse.carrierInfo.primaryContact : getPhoneData}</IonText>
                            </IonCol>
                            <IonCol className="carrierInfoRightCol">
                                <IonText className="carrierHeadings">{'Carrier Contact'}</IonText>
                                <IonText className="carrierInfoData">{(userDetails && userDetails.memberDetailsResponse &&
      userDetails.memberDetailsResponse.carrierInfo && userDetails.memberDetailsResponse.carrierInfo.otherContacts && userDetails.memberDetailsResponse.carrierInfo.otherContacts.length > 0 && 
                                (userDetails.memberDetailsResponse.carrierInfo.otherContacts[0].contactFirstName || userDetails.memberDetailsResponse.carrierInfo.otherContacts[0].contactLastName) ? 
                                getContactName(userDetails.memberDetailsResponse.carrierInfo.otherContacts[0].contactFirstName, userDetails.memberDetailsResponse.carrierInfo.otherContacts[0].contactLastName) : '-')}</IonText>
                                <IonText className="carrierHeadings">{'Email'}</IonText>
                                <IonText className="carrierInfoData">{(userDetails && userDetails.memberDetailsResponse &&
      userDetails.memberDetailsResponse.carrierInfo && userDetails.memberDetailsResponse.carrierInfo.otherContacts && userDetails.memberDetailsResponse.carrierInfo.otherContacts.length > 0 && 
      userDetails.memberDetailsResponse.carrierInfo.otherContacts[0].contactEmail ? 
                                userDetails.memberDetailsResponse.carrierInfo.otherContacts[0].contactEmail : '-')}</IonText>
                            </IonCol>
                        </IonRow>
                    </IonRow>
                    {userDetails && userDetails.memberDetailsResponse &&
      userDetails.memberDetailsResponse.carrierInfo && userDetails.memberDetailsResponse.carrierInfo.insurances && userDetails.memberDetailsResponse.carrierInfo.insurances.length > 0 && (
                        <IonRow className="mainCarrierInsuranceSection">
                            <IonRow className="carrierInfoText">
                                <IonText>{'Carrier Insurance'}</IonText>
                            </IonRow>
                            {userDetails && userDetails.memberDetailsResponse &&
      userDetails.memberDetailsResponse.carrierInfo && userDetails.memberDetailsResponse.carrierInfo.insurances && userDetails.memberDetailsResponse.carrierInfo.insurances.map((insurance: any, index: any) => (
                                <React.Fragment key={index}>
                                    <IonRow className="iconCarrierSelection">
                                        <IonIcon className="iconDimension" src="assets/icon/shield.svg" />
                                        <IonText class="iconText marginText">{insurance.insuranceTypeCode ? insurance.insuranceTypeCode : '-'}</IonText>
                                    </IonRow>
                                    <IonRow className="carrierDetailsPart">
                                        <IonCol className="carrierInfoLeftCol">
                                            <IonText className="carrierHeadings">{'Effective Date'}</IonText>
                                            <IonText className="carrierInfoData">{insurance.policyEffectiveDate ? getDateFormat(insurance.policyEffectiveDate) : '-'}</IonText>
                                            <IonText className="carrierHeadings">{'Coverage Amount'}</IonText>
                                            <IonText className="carrierInfoData">{insurance.coverageAmount ? currencyFormatter.format(insurance.coverageAmount) : '-'}</IonText>
                                        </IonCol>
                                        <IonCol className="carrierInfoRightCol">
                                            <IonText className="carrierHeadings">{'Expiration Date'}</IonText>
                                            <IonText className="carrierInfoData">{insurance.policyExpirationDate ? getDateFormat(insurance.policyExpirationDate) : '-' }</IonText>
                                        </IonCol>
                                    </IonRow>
                                </React.Fragment>
                            ))}
                        </IonRow>
                    )}
                </IonCard>
                <IonRow className="certificationRow">
                    <IonCard className="certificationCard">
                        <IonText className="certificationText">{'Certification'}</IonText>
                        {userDetails && userDetails.memberDetailsResponse &&
      userDetails.memberDetailsResponse.carrierInfo && userDetails.memberDetailsResponse.carrierInfo.certifications && userDetails.memberDetailsResponse.carrierInfo.certifications.map((item: any, index: number) => (
                            <React.Fragment key={index}>
                                <div className='certificationHead'>
                                <div className="carrierProfileCerti">
                                    <IonIcon className='alertIconDimension' src={item.certificationCode === 'Carb' ? "assets/icon/Carbweb.svg" : "assets/icon/alertInTriangle.svg"} />
                                    <IonText class="alertIconText">{item.certificationCode}</IonText>
                                </div>
                                <div>{getDateFormat(item.certificateExpireDate)}</div>
                                </div>
                                <div className="statusDiv">
                                    <IonText className='qualificationStatusText'>{'Qualification Status'}</IonText>
                                    <div className='approvedDiv'>
                                        {item.qualificationStatus === 'APPROVED' && (<IonIcon className='approvedIcon' src="assets/icon/greenTick.svg" />)}
                                        <IonText className='approvedText'>{item.qualificationStatus}</IonText>
                                    </div>
                                </div>

                                {(index !== (userDetails && userDetails.memberDetailsResponse &&
      userDetails.memberDetailsResponse.carrierInfo && userDetails.memberDetailsResponse.carrierInfo.certifications && userDetails.memberDetailsResponse.carrierInfo.certifications.length - 1)) ? (<div className='borderDiv'></div>) : null}
                            </React.Fragment>
                        ))}
                    </IonCard>
                    <div className='contactText' dangerouslySetInnerHTML={createMarkup(CARRIER_PROFILE_FOOTER)}/>
                </IonRow>
           </IonRow>
       </IonPage>
    );
}

export default CarrierProfilePage;
